var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextToSpeech(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-77b4b9f7-bb8b-4c37-9aed-b34623ed8e14",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 60,
    viewBox: "0 0 100 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m63.667,35.322c-1.104,0-2-.896-2-2v-6.644c0-1.104.896-2,2-2s2,.896,2,2v6.644c0,1.104-.896,2-2,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.333,35.322c-1.104,0-2-.896-2-2v-6.644c0-1.104.896-2,2-2s2,.896,2,2v6.644c0,1.104-.896,2-2,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.894,42.104c-1.104,0-2-.896-2-2v-20.207c0-1.104.896-2,2-2s2,.896,2,2v20.207c0,1.104-.896,2-2,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.045,38.39c-1.104,0-2-.896-2-2v-12.779c0-1.104.896-2,2-2s2,.896,2,2v12.779c0,1.104-.896,2-2,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.223,50.5c-1.104,0-2-.896-2-2V11.5c0-1.104.896-2,2-2s2,.896,2,2v37c0,1.104-.896,2-2,2Z",
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextToSpeech);
export default __webpack_public_path__ + "static/media/TextToSpeech.e3ec5e37f9ad5a009a4c20cb950f642d.svg";
export { ForwardRef as ReactComponent };